var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background background--image-login"},[_c('div',{staticClass:"layout"},[_c('nuxt',{staticClass:"layout__centered"})],1),_vm._v(" "),_c('client-only',[_c('dn-cookiebar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }